import axios from "axios";
export const API_URL = "https://srinivasafleet.com/api";

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login?reason=session_revoked";
      }
    }
    return Promise.reject(error);
  }
);

export const getRecycleBin = async (table) => {
  const response = await api.get(`/recycle-bin/${table}`);
  return response.data;
};


export const restoreRecycleBinRecord = async (table, recordId) => {
  const response = await api.post(`/recycle-bin/${table}/${recordId}/restore`);
  return response.data;
};